<script>
import BusienssService from "@/services/Business";
import Swal from "sweetalert2";

export default {
  props: ['businessWallCompanyDetails'],
  data() {
    return {
      editableBusinessWall: {},
      saving: false,
    };
  },
  watch: {
    businessWallCompanyDetails: {
      handler(newVal) {
        this.editableBusinessWall = { ...newVal };
      },
      immediate: true,
    },
  },
  methods: {
    async saveChanges() {
      if (this.saving) {
        return;
      }

      const payload = {
        order: this.editableBusinessWall.order,
      };

      try {
        this.saving = true;
        const response = await BusienssService.updateBusinessWall(this.businessWallCompanyDetails.company_id, payload);
        if (response.data.data.success) {
          // Emit event for parent to update after save
          this.$emit('update-success', this.editableBusinessWall);
          this.$emit('onRefresh');  // Emit refreshTable only after saving
          this.$bvModal.hide('edit_order_business_wall');  // Close the modal after save
          Swal.fire("Success", "Order updated successfully.", "success");
        } else {
          throw new Error('Failed to save changes');
        }
      } catch (error) {
        const message = error?.response?.data?.error || error?.message || "Error saving changes. Please try again.";
        Swal.fire("Error", Array.isArray(message) ? message.join(", ") : message, "error");
      } finally {
        this.saving = false;
      }
    },

    closeModal() {
      // Only hide the modal, no page reload or table refresh here
      if (this.saving) {
        return;
      }
      this.$bvModal.hide('edit_order_business_wall');
    },
  }

};
</script>

<template>
  <b-modal id="edit_order_business_wall" title="Edit  Order" @hidden="closeModal" size="md" centered>
    <template v-slot:default>
      <div class="row">
        <div class="col-12">
          <b-form-group label="Order">
<!--            <b-form-select v-model="editableBusinessWall.order"  :options="[-->
<!--            { value: 0, text: 'No' },-->
<!--            { value: 1, text: 'Yes' },-->
<!--    ]"  />-->
            <b-form-input type="number" v-model="editableBusinessWall.order" />
          </b-form-group>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer style="justify-content: flex-start">
      <b-button variant="light" :disabled="saving" @click="closeModal">Cancel</b-button>
      <b-button variant="primary" :disabled="saving" @click="saveChanges">
        <b-spinner v-if="saving" small class="me-1"></b-spinner>
        {{ saving ? "Saving..." : "Save Changes" }}
      </b-button>
    </template>
  </b-modal>
</template>
